// extracted by mini-css-extract-plugin
export default {"container":"PacotesSection_container__u8diT","tabs":"PacotesSection_tabs__6RMC0","activeTab":"PacotesSection_activeTab__5lsvA","tabContent":"PacotesSection_tabContent__X-Pvc"};